module.exports = require("@swa-ui/dotcom/src/MobileHeaderControl/MobileHeaderControl.module.scss");